import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { validate_letters, validate_numbers, validate_phone_number } from '@/utils/mixins/validate_inputs.js';
import {
  FIRST_TIME_LOGIN_URL,
  OTP_SENT,
  get_headers,
} from '@/utils/system_constants/constant.js';

function build_first_time_login_payload(component) {
  return {
    first_name: component.user_first_name,
    last_name: component.user_last_name,
    new_password: component.new_password,
    confirm_password: component.confirm_password,
    phone_number: component.phone_number,
    user_id: component.user_id,
  };
}

export default {
  name: 'FirstTimeLogin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex,
  },
  data: () => ({
    user_first_name: '',
    user_last_name: '',
    new_password: '',
    confirm_password: '',
    phone_number: '',
    show_password: false,
    show_confirm_password: false,
    action_running: false,
    user_id: sessionStorage.getItem('user_id') || null,
  }),
  mounted() {
    const query_user_id = this.$route.query.user_id;
    if (!this.user_id && query_user_id) {
      this.user_id = query_user_id;
    }

    if (this.user_id) {
      sessionStorage.setItem('user_id', this.user_id);
    }
  },
  methods: {
    toggle_password_visibility() {
      this.show_password = !this.show_password;
    },
    toggle_confirm_password_visibility() {
      this.show_confirm_password = !this.show_confirm_password;
    },
    validate_numbers_only(event) {
      validate_numbers(event);
    },
    validate_phone_number(phone_number) {
      return validate_phone_number(phone_number);
    },
    build_payload() {
      return build_first_time_login_payload(this);
    },
    validate_inputs() {
      if (!this.user_id) {
        this.show_error('Could not determine the user for first-time login.');
        return false;
      }

      if (!this.user_first_name.trim() || !this.user_last_name.trim()) {
        this.show_info('First name and last name are required.');
        return false;
      }

      if (!validate_phone_number(this.phone_number)) {
        this.show_info('Please enter a valid 10-digit phone number.');
        return false;
      }

      if (!this.new_password) {
        this.show_info('Password is required.');
        return false;
      }

      if (!this.confirm_password) {
        this.show_info('Please confirm your password.');
        return false;
      }

      if (this.new_password !== this.confirm_password) {
        this.show_info('Passwords do not match.');
        return false;
      }

      return true;
    },
    async first_time_login() {
      if (!this.validate_inputs()) {
        return;
      }

      this.action_running = true;

      try {
        const response = await axios.post(
          FIRST_TIME_LOGIN_URL,
          this.build_payload(),
          { headers: get_headers() }
        );

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        if (response_data.status !== 'success') {
          this.show_error(response_data.message || 'Error during the form submission.');
          return;
        }

        if (response_data.user_id) {
          this.user_id = response_data.user_id;
          sessionStorage.setItem('user_id', this.user_id);
        }

        if (response_data.profile_role_form_id) {
          sessionStorage.setItem('profile_role_form_id', response_data.profile_role_form_id);
        }

        await axios.post(
          OTP_SENT,
          { user_id: this.user_id },
          { headers: get_headers() }
        ).catch(() => {
          this.show_error('Could not send OTP to user.');
        });

        this.show_success(response_data.message || 'Password updated successfully.');
        this.$router.push({
          path: '/one_time_pin',
          query: { user_id: this.user_id },
        });
      } catch (error) {
        this.show_error(
          error?.response?.data?.message
          || error?.response?.data?.details
          || 'An unexpected error occurred. Please try again.'
        );
      } finally {
        this.action_running = false;
      }
    },
    validate_letters_only(event) {
      validate_letters(event);
    },
  },
};
